<template>
  <span v-if="show" class="error-label">{{error}}<input class="focuser" style="height: 0px; opacity: 0;"></span>
</template>
<script setup lang="ts">
import { computed, inject } from 'vue'
import type { Form } from '~/shared/form-types'
import { usePaymentForm } from '~/shared/use-payment-form'

const props = defineProps<{
  field?: string
  customError?: string
}>()

const { errors, isTouched } = usePaymentForm()

// inject must be called at setup time, not in computed
const injectedField = inject<string>('field', '')
const theField = computed(() => props.field || injectedField)

const show = computed(() => {
  if (!theField.value || !errors.value) return false
  const field = theField.value as keyof typeof errors.value
  const errorKey = theField.value.replace(/\./g, ',')
  const touched = isTouched(field)
  const hasError = errorKey in errors.value

  return !!(field && touched && hasError)
})

const error = computed(() => {
  if (!theField.value || !errors.value) return ''
  const errorKey = theField.value.replace(/\./g, ',') as keyof typeof errors.value
  return props.customError || errors.value[errorKey] || ''
})
</script>
<style scoped>
.error-label {
  font-size: 10px;
  color: red;
  font-style: normal;
  width: 100%;
  display: block;
  margin-top: 3px;
  position: absolute;
}
</style>
